<template>
    <div>
        <v-form>
            <v-card-text>
                <v-radio-group v-model="option">
                    <v-banner class="form__item">
                        <!-- <span @click="option = 'RuleCreator'" class="radio-label"> -->
                        <!-- </span> -->
                        <v-radio color="secondary" label="All french people" value="RuleCreator">
                        </v-radio>
                        <span class="form__item-hint">Panel of French accounts</span>
                    </v-banner>
                    <v-banner class="form__item">
                        <!-- <span @click="updateValue('ExistingCommunities')" class="radio-label"> -->
                        <!-- </span> -->
                        <v-radio color="secondary" label="Existing community" value="VennDiagram">
                        </v-radio>
                    </v-banner>
                    <!-- <v-banner class="form__item"> -->
                    <!--     <\!-- <span @click="updateValue('CSVUpload')" class="radio-label"> -\-> -->
                    <!--     <\!-- </span> -\-> -->
                    <!--     <v-radio color="secondary" label="A list of accounts" value="CSVUpload"> -->
                    <!--     </v-radio> -->
                    <!--     <span class="form__item-hint">Import .csv on lucy</span> -->
                    <!-- </v-banner> -->
                </v-radio-group>
            </v-card-text>
        </v-form>
    </div>
</template>

<script>
    export default {
        name: "CommunityType",
        props: ["value"],
        data: () => ({
            option: null,
        }),
        methods: {
            updateValue: function (val) {
                this.option = val
            }
        },
        watch: {
            value (val) {
                this.option = val
            },
            option (val) {
                this.$emit('input', val)
                this.$emit('confirm', val)
            }
        }
    }
</script>

<style scoped>

</style>
